export default "__VITE_ASSET__BJAj7vLa__"